<div class="card">
  <p-table
    [value]="auditLogs"
    styleClass="p-datatable-striped p-datatable-sm"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th>Time</th>
        <th>Type</th>
        <th>Action</th>
        <th>Edited By</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-auditLog let-expanded="expanded">
      <tr>
        <td>
          <i
            [class]="
              expanded
                ? 'bi bi-chevron-down expand-data-section'
                : 'bi bi-chevron-right expand-data-section'
            "
            [pRowToggler]="auditLog"
          ></i>
        </td>
        <td>
          {{ auditLog.timestamp | date : 'dd/MM/yyyy HH:mm' }}
        </td>
        <td>{{ auditLog.type }}</td>
        <td>{{ auditLog.action }}</td>
        <td>{{ auditLog?.editedBy?.username ?? "N/A" }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-auditLog>
      <tr>
        <td colspan="5">
          <div class="pl-5">
            <pre> {{ stringifyData(auditLog.dataJson) }}</pre>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
